import * as React from "react";
import "./truncated-text.css";

export default function TruncatedText({ text }: { text?: string; }): JSX.Element {
    return <span className="truncatedText">{text}</span>
}
